import React, { Fragment } from 'react';

import ProductPrice from '../Interface/ProductPrice';
import { B2CDiscountUnit, B2CRentalUnitOfMeasure } from '../Enums';
import { numberToDecimalString } from '../../../utils';
import {
  Container,
  DiscountDisclaimer,
  Header,
  PreDiscountPriceSpan,
  Price,
  PriceDescriptionSpan,
} from './ProductCardPrice.style';
import { CurrencySymbols } from 'src/constants/currencySymbols';
import { Currencies } from 'src/enums';

interface ProductCardPrice {
  price?: ProductPrice;
  liability?: number;
  prepaid?: boolean;
  included?: boolean;
  isUpgrade?: boolean;
  hideDisclamer?: boolean;
}

const ProductCardPrice = ({
  price,
  liability,
  prepaid,
  included,
  isUpgrade,
  hideDisclamer,
}: ProductCardPrice) => {
  const {
    amount,
    originalAmount,
    rateValue,
    originalRateValue,
    adjustments,
    unitOfMeasure,
    currency,
  } = price || {};

  const adjustmentDiscountValue = adjustments?.[0]?.discount;
  const isDiscount =
    (originalRateValue || originalAmount) && adjustmentDiscountValue;
  const showFullPrice = ![
    B2CRentalUnitOfMeasure.DAY,
    B2CRentalUnitOfMeasure.NIGHT,
  ].includes(unitOfMeasure);
  const currencySymbol =
    CurrencySymbols[currency] ?? CurrencySymbols[Currencies.NZD];

  return (
    <Container className="product-card-price-container">
      {prepaid || included ? (
        <Price>{prepaid ? 'Prepaid' : 'Included'}</Price>
      ) : (
        <>
          <Header>
            {showFullPrice ? (
              <Price>
                {!!isUpgrade && `+`}
                {currencySymbol}
                {numberToDecimalString(amount)}
              </Price>
            ) : (
              <Fragment>
                <div>
                  <Price>
                    {!!isUpgrade && `+`}
                    {currencySymbol}
                    {numberToDecimalString(rateValue)}
                  </Price>
                  <PriceDescriptionSpan>
                    /{unitOfMeasure?.toLowerCase()}
                  </PriceDescriptionSpan>
                </div>
              </Fragment>
            )}
            {!!isDiscount && !hideDisclamer && (
              <DiscountDisclaimer>
                {adjustmentDiscountValue?.unit === B2CDiscountUnit.PERCENTAGE
                  ? `Save ${adjustmentDiscountValue.value?.toFixed(0)}%`
                  : `Save ${currencySymbol}${numberToDecimalString(
                      adjustmentDiscountValue.value,
                    )}`}
              </DiscountDisclaimer>
            )}
          </Header>
          {!!isDiscount && (
            <PreDiscountPriceSpan>
              {currencySymbol}
              {showFullPrice
                ? numberToDecimalString(originalAmount)
                : `${numberToDecimalString(
                    originalRateValue,
                  )}/${unitOfMeasure?.toLowerCase()}`}
            </PreDiscountPriceSpan>
          )}
        </>
      )}
      {liability !== null && liability !== undefined && (
        <PriceDescriptionSpan>
          {`You are liable for up to ${currencySymbol}${numberToDecimalString(
            liability,
          )} per incident (subject to exclusions - refer to rental agreement).`}
        </PriceDescriptionSpan>
      )}
    </Container>
  );
};

export default ProductCardPrice;
